import styled from 'styled-components'

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

export const AverageBeatsPerMinute = styled.div`
  display: flex;
  align-items: flex-end;
  column-gap: 4px;
`

export const AvgValue = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 40px;
  color: ${props => props.theme.colors.color2d3139};
`

export const AvgUnit = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Range = styled.div`
  display: flex;
  flex-direction: column;
`

export const MaximumBeatsPerMinute = styled.div`
  display: flex;
  column-gap: 4px;
  align-items: flex-end;
`

export const MaxValue = styled.div``

export const MinimumBeatsPerMinute = styled.div`
  display: flex;
  column-gap: 4px;
  align-items: flex-end;
`

export const MinValue = styled.div``

export const Label = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  color: ${props => props.theme.colors.color545e6c};
`
